module.exports = __webpack_public_path__ + "static/img/page_PLAY_over.86277d9.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/sprite/course/page_PLAY_over.png
// module id = l3yj
// module chunks = 0